import { Root } from '@amcharts/amcharts5';

export type FormattingSettings = {
  numberFormatter?: {};
  dateFormatter?: {};
};

export const setFormatting = (root: Root, settings: FormattingSettings) => {
  settings.numberFormatter && root.numberFormatter.setAll(settings.numberFormatter);
  settings.dateFormatter && root.dateFormatter.setAll(settings.dateFormatter);
};
